import React, {useState, useMemo, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels, currentResource} from '../../../util/utils';
import env from '../../../util/env';
import Button from '../../Common/BaseComponentWrappers/MotifButton';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import {smartScreenRoutes, canvasUrlParams, loadingIndicatorTypes} from '../../../util/uiconstants';
import {submitIndependenceTemplate} from '../../../actions/FormData/formdataactions';
import {raiseJSValidationError} from '../../../actions/erroractions';

function SubmitIndependenceButton(props) {
	const {engagementId, documentId, disabled} = props;

	const [isSubmitting, setIsSubmitting] = useState(false);
	const genericErrorCode = '7026';

	const dispatch = useDispatch();

	const independenceSummaryUrl = useMemo(() => {
		return (
			env.getURL('hercules_web') +
			smartScreenRoutes.independence +
			'?' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.documentId +
			'=' +
			documentId
		);
	}, [engagementId, documentId]);

	const onClick = useCallback(() => {
		return dispatch(submitIndependenceTemplate(engagementId, documentId))
			.then(() => {
				window.location.href = independenceSummaryUrl;
			})
			.catch(() => {
				dispatch(raiseJSValidationError(currentResource.Errors[genericErrorCode]));
				setIsSubmitting(false);
			})
			.finally(() => {
				setIsSubmitting(false);
			});
	}, [engagementId, documentId]);

	return (
		<StyledWrapper className="StyledWrapper">
			<StyledSubmitIndependenceButton
				onClick={() => {
					setIsSubmitting(true);
					return onClick();
				}}
				variant="primary-alt"
				size="large"
				disabled={disabled}
				showLabel
				isEllipsed
				buttonLabel={labels.submitTemplate}
				noOfLines={1}
			/>
			<LoadingIndicator indicatorType={loadingIndicatorTypes.standard} show={isSubmitting} fullscreen />
		</StyledWrapper>
	);
}

SubmitIndependenceButton.propTypes = {
	engagementId: PropTypes.number.isRequired,
	documentId: PropTypes.string.isRequired,
	disabled: PropTypes.bool
};

export default SubmitIndependenceButton;

const StyledSubmitIndependenceButton = styled(Button)`
	width: 85%;

	.ellipses {
		justify-content: center;
	}
`;

const StyledWrapper = styled.section`
	padding: var(--px-20);
`;
